var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinishedProductsRecord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "65px",
    width: "65px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-76.8 -76.8 665.60 665.60",
    xmlSpace: "preserve",
    stroke: "#000000",
    strokeWidth: 0.00512,
    transform: "rotate(0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 1.024
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.353,286.389l30.519,22.17l-30.519,22.17c-7.981,5.798-9.751,16.966-3.953,24.946 c5.799,7.984,16.967,9.749,24.947,3.953l36.294-26.364c44.627,45.825,135.83,37.294,165.213-16.093 c2.952-5.362,2.952-11.862,0-17.223c-29.323-53.28-120.475-62.033-165.213-16.093l-36.294-26.364 c-7.979-5.799-19.15-4.029-24.947,3.953C137.602,269.423,139.372,280.591,147.353,286.389z M332.083,308.56 c-24.463,24.988-77.272,24.951-101.699,0C254.846,283.572,307.655,283.608,332.083,308.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.591,0H37.41c-9.864,0-17.86,7.997-17.86,17.86v105.118c0,9.864,7.997,17.86,17.86,17.86h24.856v353.3 c0,9.864,7.997,17.86,17.86,17.86h351.748c9.864,0,17.86-7.997,17.86-17.86v-353.3h24.856c9.864,0,17.86-7.997,17.86-17.86V17.86 C492.452,7.997,484.455,0,474.591,0z M414.015,402.954H97.987V214.165h316.027v188.789H414.015z M97.987,476.279v-37.605h316.027 v37.605H97.987z M414.015,178.444H97.987v-37.605h316.027v37.605H414.015z M456.731,105.118c-7.632,0-399.016,0-401.46,0V35.721 h401.46V105.118z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedProductsRecord);
export default __webpack_public_path__ + "static/media/finished_products_record.3af1618fb0397b0f8feeb0be63126f3c.svg";
export { ForwardRef as ReactComponent };